import { requestCDN, requestGlobalSettingData, requestMain, requestSignIn } from "../../apis";
import localStorageKey from "../../enumerations/localStorageKey";

const defaultCurrency = localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);

//PROMOTIONS

export const apiGetPromotionType = () => {
  const millis = Date.now();
  return requestCDN("get", `/${defaultCurrency?.toUpperCase()}/promotion/type.json?v=${millis}`);
  // return requestGlobalSettingData("get", `/${defaultCurrency}/promotion/type`, {}, false, false);
};

export const apiGetPromotionList = ({ params, page_size, page }) =>
  requestMain("get", `/${defaultCurrency}/promotion`, { ...params, page_size, page }, false, false);

export const apiGetPromotionDetail = ({ promotionId, params }) =>
  requestMain("get", `/${defaultCurrency}/promotion/${promotionId}`, params, false, false);

export const apiGetPromotionDepositRecord = ({ transId }) =>
  requestMain("get", `/${defaultCurrency}/promotion/${transId}/deposit/record`, {}, true, false);

export const apiPutPromotionDepositRecordClaim = ({ id }) =>
  requestMain("put", `/${defaultCurrency}/promotion/deposit/record/claim`, { id }, true, false);

export const apiGetGameCategory = ({ params }) =>
  requestGlobalSettingData(
    "get",
    `/${defaultCurrency}/game/category/promotion`,
    params,
    false,
    false,
  );

export const apiGetGameProduct = ({ categoryId, params }) =>
  requestGlobalSettingData(
    "get",
    `/${defaultCurrency}/game/${categoryId}/promotion`,
    params,
    false,
    false,
  );

export const apiPostDaily = () =>
  requestSignIn("put", `/${defaultCurrency}/promotion/bet/bonus/apply`, {}, true, true);

//VIP
export const apiGetGameRebate = ({ params }) =>
  requestGlobalSettingData("get", `/${defaultCurrency}/game/rebate/notallow`, params, false, false);

export const apiGetUserLevelInfo = ({ params }) =>
  requestMain("get", `/${defaultCurrency}/user/level/info`, params, true, false);
